

function positionOrderSummary(scroll) {
    var orderSummary = $('#orderSummary');
    if (orderSummary) {
        orderSummary.css('transform', 'translateY(' + scroll + 'px)');
    }
}

function areAllItemsVisible() {
    var headerHeight = $('.header').prop('scrollHeight');
    var osHeight = $('#orderSummary').prop('scrollHeight');
    var itemsDivHeight = $('#items').prop('scrollHeight');
    var footerHeight = 0;
    if (!$('#orderSummary').hasClass('pushDown')) {
        footerHeight = $('.footer').prop('scrollHeight');
    }
    var windowInnerHeight = window.innerHeight;
    var availableSpaceForItems = windowInnerHeight - (headerHeight + osHeight + footerHeight);
    return availableSpaceForItems > itemsDivHeight;
}

$.fn.isOnScreen = function () {

    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
};

module.exports = {

    getEachItemMaxHeight: function getEachItemMaxHeight(cartItems, index) {
        var itemDetailsHeight = 0,
            itemNameHeight = 0,
            itemNumberHeight = 0;
        var itemDetails = $('#itemDetails' + index);
        var itemName = $('#item' + index + 'name');
        var itemNumber = $('#item' + index + 'number');
        var item = $('#item' + index);

        if (cartItems[index] && cartItems[index].details && itemDetails) {
            itemDetailsHeight = itemDetails.prop('scrollHeight'); // to accommodate details
        }

        if (itemName) {
            if (angular.element('#item' + index + 'name').hasClass('ellipsisEffect')) {
                // to get maxHeight full max height (without ellipsis effect), we remove the effect and then add back
                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
                itemNameHeight = itemName.prop('scrollHeight');
                angular.element('#item' + index + 'name').addClass('ellipsisEffect');
            } else {
                itemNameHeight = itemName.prop('scrollHeight');
            }
        }
        if (itemNumber) {
            if (angular.element('#item' + index + 'number').hasClass('ellipsisEffect')) {
                // to get maxHeight full max height (without ellipsis effect), we remove the effect and then add back
                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
                itemNumberHeight = itemNumber.prop('scrollHeight');
                angular.element('#item' + index + 'number').addClass('ellipsisEffect');
            } else {
                itemNumberHeight = itemNumber.prop('scrollHeight');
            }
        }
        return item.prop('scrollHeight') + itemDetailsHeight + itemNameHeight + itemNumberHeight;
    },

    getItemsMaxHeight: function getItemsMaxHeight(cartItems, index, scrolledToEnd) {
        var shoppingCartPageHeader = $('.header');
        var orderSummaryHead = $('#orderSummaryHead');
        var checkoutButtons = $('.checkoutButtons');
        var footer = $('.footer');
        var windowInnerHeight = window.innerHeight;
        var itemsMaxHeight = void 0;
        if (scrolledToEnd) {
            itemsMaxHeight = windowInnerHeight - shoppingCartPageHeader.prop('scrollHeight') - orderSummaryHead.prop('scrollHeight') - checkoutButtons.prop('scrollHeight') - footer.prop('clientHeight');
        } else {
            itemsMaxHeight = windowInnerHeight - shoppingCartPageHeader.prop('scrollHeight') - orderSummaryHead.prop('scrollHeight') - checkoutButtons.prop('scrollHeight');
        }
        $('#items').css('max-height', itemsMaxHeight + 'px');
        return itemsMaxHeight;
    },

    getDetailsMaxHeight: function getDetailsMaxHeight(index) {
        return $('#itemDetails' + index).prop('scrollHeight');
    },

    getItemNameMaxHeight: function getItemNameMaxHeight(index) {
        return $('#item' + index + 'name').prop('scrollHeight');
    },

    getContainerColWidth: function getContainerColWidth() {
        return $('#itemProperties').width();
    },

    areAllItemsVisible: areAllItemsVisible,

    setOrderSummaryColor: function setOrderSummaryColor() {

        if (areAllItemsVisible()) {
            $('#orderSummaryHead').addClass('opaque');
            $('.details-expand').addClass('opaque');
        } else {
            $('#orderSummaryHead').removeClass('opaque');
            $('.details-expand').removeClass('opaque');
        }
    },

    initWindowScrollActions: function initWindowScrollActions() {
        $('#orderSummary').css('bottom', $('.footer').prop('scrollHeight') + 1);
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            var cartContentsHeight = $('#cartContents').prop('scrollHeight');
            var osHeight = $('#orderSummary').prop('scrollHeight');
            var scrollLimit = cartContentsHeight - osHeight - 25; // allow for padding
            if (!$('.footer').isOnScreen() && scroll < scrollLimit) {
                positionOrderSummary(scroll);
            } else {
                positionOrderSummary(0);
            }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shopping-cart/cartUiUtil.js
// module id = ./pages/xo-shopping-cart/cartUiUtil.js
// module chunks = 1